import { useNuxtApp } from "#app";

const SHOP_QUERY = "isShop=1&uncheck401=1";

function post(path, param) {
  return useNuxtApp().$customFetch(`/mall${path}${path.includes("?") ? "&" : "?"}${SHOP_QUERY}`, {
    method: "POST",
    body: typeof param === "undefined" ? undefined : { param },
  });
}

export function getAustraliaComboProductDetail({ comboCode, dealerShopId = "" }) {
  const query = new URLSearchParams({ comboCode: String(comboCode || "") });
  if (dealerShopId) query.set("dealerShopId", String(dealerShopId));
  return post(`/admin/mallComboProduct/queryByCode?${query.toString()}`);
}

export function calculateAustraliaComboInventory({ comboCode, dealerShopId = "" }) {
  const query = new URLSearchParams({ comboCode: String(comboCode || "") });
  if (dealerShopId) query.set("dealerShopId", String(dealerShopId));
  return post(`/admin/mallComboProduct/calculateInventory?${query.toString()}`);
}

export function addAustraliaMixedCartItem(param) {
  return post("/admin/mallShoppingCart/mixed/add", param);
}

export function modifyAustraliaMixedCartItem(param) {
  return post("/admin/mallShoppingCart/mixed/modify", param);
}

export function deleteAustraliaMixedCartItems(param) {
  return post("/admin/mallShoppingCart/mixed/delete", param);
}

export function getAustraliaMixedCartList(param = {}) {
  return post("/admin/mallShoppingCart/mixed/list", {
    pageNo: 0,
    pageSize: 100,
    itemType: null,
    ...param,
  });
}

export function getAustraliaMixedCartAmount(param) {
  return post("/admin/mallShoppingCart/mixed/getAmount", param);
}

export function confirmAustraliaComboOrder(param) {
  return post("/admin/mallOrder/confirmComboOrder", {
    countryCode: param.countryCode || "AU",
    confirmOrderSkuReqDTOList: param.confirmOrderSkuReqDTOList || [],
  });
}

export function calculateAustraliaComboSettlementAmount(param) {
  return post("/admin/mallOrder/calculateComboSettlementAmount", param);
}

export function calculateAustraliaComboDiscountDetail(param) {
  return post("/admin/mallOrder/calculateComboDiscountDetail", param);
}

export function createAustraliaComboOrder(param = {}) {
  return post("/admin/mallOrder/createComboOrder", {
    ...param,
    countryCode: param.countryCode || param.customerAddressDTO?.countryCode || "AU",
    createOrderSkuReqDTOList: param.createOrderSkuReqDTOList || [],
  });
}
